<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

  <p-tabView>

    <p-tabPanel header="Profile">
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="portalAccess" optionLabel="name"
            optionValue="value" placeholder="Portal Access"></p-dropdown>
            <label for="portalAccess">Portal Access</label>
            @for (validation of validationMessages.portalAccess; track validation) {
              <span>
                @if (form1.get('portalAccess').hasError(validation.type) && (form1.get('portalAccess').dirty || form1.get('portalAccess').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="portalRegisterDate" inputId="portalRegisterDate" appendTo="body">
            </p-calendar>
            <label for="portalRegisterDate">Portal Register Date</label>
            @for (validation of validationMessages.portalRegisterDate; track validation) {
              <span>
                @if (form1.get('portalRegisterDate').hasError(validation.type) && (form1.get('portalRegisterDate').dirty || form1.get('portalRegisterDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <h6 class="pt-3">Contact</h6>

        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="titles" formControlName="title" optionLabel="name"
              optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
            placeholder="Title"></p-dropdown>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-4">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="suffix" id="suffix" type="text" pInputText>
            <label for="suffix">suffix</label>
            @for (validation of validationMessages.suffix; track validation) {
              <span>
                @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
            <label for="emailAddress">Email Address</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="mailAdrPhone" id="mailAdrPhone" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
          <label for="mobilePhone">Mobile Phone</label>
          @for (validation of validationMessages.mobilePhone; track validation) {
            <span>
              @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>
      <div class="col-lg-6"></div>
      <div class="col-lg-6"></div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="percentages" formControlName="defaultCommissionPCT" optionLabel="name"
          optionValue="value" placeholder="Default Commission PCT"></p-dropdown>
          <label for="defaultCommissionPCT">Default Commission PCT</label>
          @for (validation of validationMessages.defaultCommissionPCT; track validation) {
            <span>
              @if (form1.get('defaultCommissionPCT').hasError(validation.type) && (form1.get('defaultCommissionPCT').dirty || form1.get('defaultCommissionPCT').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <h6 class="pt-3">Agency Information</h6>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="agencyName" id="agencyName" type="text" pInputText>
          <label for="agencyName">Agency Name</label>
          @for (validation of validationMessages.agencyName; track validation) {
            <span>
              @if (form1.get('agencyName').hasError(validation.type) && (form1.get('agencyName').dirty || form1.get('agencyName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="websiteUrl" id="websiteUrl" type="text" pInputText>
          <label for="websiteUrl">Website URL</label>
          @for (validation of validationMessages.websiteUrl; track validation) {
            <span>
              @if (form1.get('websiteUrl').hasError(validation.type) && (form1.get('websiteUrl').dirty || form1.get('websiteUrl').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="iatalicNum" id="iatalicNum" type="text" pInputText>
          <label for="iatalicNum">IATALic Number</label>
          @for (validation of validationMessages.iatalicNum; track validation) {
            <span>
              @if (form1.get('iatalicNum').hasError(validation.type) && (form1.get('iatalicNum').dirty || form1.get('iatalicNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="trueNum" id="trueNum" type="text" pInputText>
          <label for="trueNum">TRUE Number</label>
          @for (validation of validationMessages.trueNum; track validation) {
            <span>
              @if (form1.get('trueNum').hasError(validation.type) && (form1.get('trueNum').dirty || form1.get('trueNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="arcNum" id="arcNum" type="text" pInputText>
          <label for="arcNum">ARC Number</label>
          @for (validation of validationMessages.arcNum; track validation) {
            <span>
              @if (form1.get('arcNum').hasError(validation.type) && (form1.get('arcNum').dirty || form1.get('arcNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <input formControlName="cliaNum" id="cliaNum" type="text" pInputText>
          <label for="cliaNum">CLIA Number</label>
          @for (validation of validationMessages.cliaNum; track validation) {
            <span>
              @if (form1.get('cliaNum').hasError(validation.type) && (form1.get('cliaNum').dirty || form1.get('cliaNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="affiliationTypes" formControlName="affiliationType" optionLabel="name"
          optionValue="value" placeholder="Affiliation Type"></p-dropdown>
          <label for="affiliationType">Affiliation Type</label>
          @for (validation of validationMessages.affiliationType; track validation) {
            <span>
              @if (form1.get('affiliationType').hasError(validation.type) && (form1.get('affiliationType').dirty || form1.get('affiliationType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6"></div>

      <h6 class="pt-3">Address</h6>

      <div class="col-lg-4">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="addressTypes" formControlName="adrType" optionLabel="name"
          optionValue="value" placeholder="Select Address Type"></p-dropdown>
          <label for="Select Address Type">Select Address Type</label>
          @for (validation of validationMessages.adrType; track validation) {
            <span>
              @if (form1.get('adrType').hasError(validation.type) && (form1.get('adrType').dirty || form1.get('adrType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-8">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrCompanyName" id="adrCompanyName" type="text" pInputText>
          <label for="adrCompanyName">Adr Company Name</label>
          @for (validation of validationMessages.adrCompanyName; track validation) {
            <span>
              @if (form1.get('adrCompanyName').hasError(validation.type) && (form1.get('adrCompanyName').dirty || form1.get('adrCompanyName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrStreet" id="adrStreet" type="text" pInputText>
          <label for="adrStreet">Adr Street</label>
          @for (validation of validationMessages.adrStreet; track validation) {
            <span>
              @if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrStreet2" id="adrStreet2" type="text" pInputText>
          <label for="adrStreet2">Adr Street2</label>
          @for (validation of validationMessages.adrStreet2; track validation) {
            <span>
              @if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrIsland" id="adrIsland" type="text" pInputText>
          <label for="adrIsland">Adr Island</label>
          @for (validation of validationMessages.adrIsland; track validation) {
            <span>
              @if (form1.get('adrIsland').hasError(validation.type) && (form1.get('adrIsland').dirty || form1.get('adrIsland').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrCity" id="adrCity" type="text" pInputText>
          <label for="adrCity">Adr City</label>
          @for (validation of validationMessages.adrCity; track validation) {
            <span>
              @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="states" formControlName="adrState" optionLabel="name" appendTo="body"
            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="State">
          </p-dropdown>
          <label for="adrState">Adr State</label>
          @for (validation of validationMessages.adrState; track validation) {
            <span>
              @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown [options]="countries" formControlName="adrCountry" optionLabel="name" appendTo="body"
            optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
            placeholder="Country">
          </p-dropdown>
          <label for="adrCountry">Adr Country</label>
          @for (validation of validationMessages.adrCountry; track validation) {
            <span>
              @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
          <label for="adrPostalCode">Adr Postal Code</label>
          @for (validation of validationMessages.adrPostalCode; track validation) {
            <span>
              @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-3">
        <span class="p-float-label required-field w-100 mb-3">
          <!-- <p-inputMask formControlName="adrPhone" id="adrPhone" mask="(999) 999-9999" type="text">
        </p-inputMask> -->
        <input formControlName="adrPhone" id="adrPhone" type="text" pInputText>
        <label for="adrPhone">Adr Phone</label>
        @for (validation of validationMessages.adrPhone; track validation) {
          <span>
            @if (form1.get('adrPhone').hasError(validation.type) && (form1.get('adrPhone').dirty || form1.get('adrPhone').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
    <div class="col-lg-6"></div>

    <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
        <label for="opsNotes">Ops Notes</label>
        @for (validation of validationMessages.opsNotes; track validation) {
          <span>
            @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>

  </div>
</div>
    </p-tabPanel>

    @if (travelAgentProfileId) {
      <p-tabPanel header="Reservations" (click)="loadReservations()">
        <div class="d-flex justify-content-between mb-2">
          <div class="tab-actions">
            <button class="btn-export" (click)="downloadCommissionCsv()" [disabled]="!reservations?.length">
              <i class="pi pi-download"></i> Download CSV
            </button>
          </div>
          <button pButton class="p-button-sm p-button-outlined" (click)="loadReservations()" [disabled]="reservationsLoading">
            Refresh
          </button>
        </div>
        <p-table [value]="reservations" [loading]="reservationsLoading" styleClass="p-datatable-striped p-datatable-sm"
          [scrollable]="true" scrollHeight="400px">
          <ng-template pTemplate="header">
            <tr>
              <th>Res #</th>
              <th>Guest</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Nights</th>
              <th>Booking Amt</th>
              <th>Commission Amt</th>
              <th>Pay Status</th>
              <th>Pay Date</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-res>
            <tr>
              <td>{{res.reservationId}}</td>
              <td>{{res.guestName}}</td>
              <td>{{res.checkInDate | date:'MM/dd/yy'}}</td>
              <td>{{res.checkOutDate | date:'MM/dd/yy'}}</td>
              <td>{{res.numNights}}</td>
              <td>{{res.bookingAmt | currency}}</td>
              <td>{{res.commissionAmt | currency}}</td>
              <td>
                @if (res.commissionPayStatus === 'PAID') {
                  <span class="badge bg-success">PAID</span>
                } @else {
                  <span class="badge bg-secondary">{{res.commissionPayStatus || 'UNPAID'}}</span>
                }
              </td>
              <td>{{res.commissionPayDate | date:'MM/dd/yy'}}</td>
              <td>
                @if (res.commissionPayStatus !== 'PAID') {
                  <button pButton class="p-button-sm p-button-success" (click)="markCommissionPaid(res)">
                    Mark Paid
                  </button>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" class="text-center text-muted">No reservations found. Click Refresh to load.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    }

    @if (travelAgentProfileId) {
      <p-tabPanel header="W-9">
        <div [formGroup]="form1" class="w9-admin-section">
          <div class="field-group">
            <label>W-9 Status</label>
            <p-dropdown formControlName="w9Status"
              [options]="w9StatusOptions"
              optionLabel="label" optionValue="value"
              placeholder="Not submitted"
              styleClass="w-full">
            </p-dropdown>
          </div>
          <div class="field-group">
            <label>Upload Date</label>
            <input type="text" [value]="form1.get('w9UploadDate')?.value || '—'" class="form-input" readonly />
          </div>
          <div class="field-group" *ngIf="form1.get('w9Url')?.value">
            <label>W-9 File</label>
            <a [href]="'https://task-kbm-hawaii-master.s3.amazonaws.com/' + form1.get('w9Url')?.value"
               target="_blank" class="btn-link">
              <i class="pi pi-file-pdf"></i> View W-9
            </a>
          </div>
          <div *ngIf="!form1.get('w9Url')?.value" class="no-w9">
            <i class="pi pi-exclamation-triangle"></i> No W-9 on file
          </div>
        </div>
      </p-tabPanel>
    }

  </p-tabView>

<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (travelAgentProfileId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!travelAgentProfileId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (travelAgentProfileId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
            <button pButton class="p-button p-button-success ml-2" (click)="activatePortalAccess()" [disabled]="formLoading"
              pTooltip="Create login account and send invite email" tooltipPosition="top">
              Activate Portal &amp; Send Invite
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>